namespace Areas.Inspections {
    "use strict";

    export function status(cellElement, cellInfo) {

        cellElement.html(cellInfo.data.statusLk);

        if (cellInfo.data.statusLk == 'Accepted') {
            $(cellElement).css('background-color', 'lightgreen');
        } else if (cellInfo.data.statusLk == 'Pending') {
            $(cellElement).css('background-color', 'gold');
        } else if (cellInfo.data.statusLk == 'ReInspected') {
            $(cellElement).css('background-color', 'pink');
        } else if (cellInfo.data.statusLk == 'Rejected') {
            $(cellElement).css('background-color', 'red'); 
        }

    }

}